import type {RequestMethod} from '../types/request';

interface RequestErrorProps<TErrorData> {
  message: string;
  status?: number;
  response?: Response;
  data?: TErrorData;
  url: string;
  method: RequestMethod;
  requestId?: string;
  cause?: unknown;
}

/**
 * Structured error thrown by {@link request} on HTTP failures or network errors.
 *
 * Carries the original `Response`, parsed error body, HTTP status, correlation ID,
 * and the request URL/method for diagnostics.
 */
export class RequestError<TErrorData = unknown> extends Error {
  public readonly status?: number;
  public readonly response?: Response;
  public readonly data?: TErrorData;
  public readonly url: string;
  public readonly method: RequestMethod;
  public readonly requestId?: string;

  public constructor({
    message,
    status,
    response,
    data,
    url,
    method,
    requestId,
    cause,
  }: RequestErrorProps<TErrorData>) {
    super(message, {cause});
    this.name = 'RequestError';
    this.status = status;
    this.response = response;
    this.data = data;
    this.url = url;
    this.method = method;
    this.requestId = requestId;
  }
}
